export const Data = [
    {
      id: '1',
      title: 'Class X',
      date:'2019',
      subtitle:'Podar International School, Jalna',
      icon: <img src="/school.png" className='rounded-full' alt='school'/>,
      score: '86.4%',
      description: `I attended Podar International School, where I studied under the CBSE board curriculum. Through dedicated effort and commitment to my studies, I achieved a score of 86.4% in my board examinations. This accomplishment reflects my strong academic foundation and consistent performance across subjects.`
    },
    {
        id: '2',
        title: 'Higher Secondary Education',
        date:'2019-2021',
        subtitle:'Yogiraj Public School, Kota',
        icon: <img src="/twelthschool.jpeg" className='rounded-full' alt='school'/>,
        score: '82.5%',
        description: `Attended Yogiraj Public School, Kota for Higher Secondary Education with a PCM major in the CBSE curriculum. 
        Gained solid skills in scientific and mathematical concepts.`
    },
    {
    id:'3',
    date: '2022 - 2026',
    icon: <img src="/college.jpeg" className='rounded-full' alt='college' />,
    score:'Grade: 7.9',
    title: 'Graduation',
    subtitle: 'B.Tech In CSE, IIIT Nagpur',
    description: `I am a B.Tech Computer Science student at IIIT, building a strong foundation in coding, algorithms, and software development for a tech career.







`
      }
  ];

  export const JobData = [
    {
      company: 'Mindtickle',
      position: 'Software Development Engineer Intern',
      duration: 'August 2025 - Present',
      points: [
        'Improved crash-free user rate from 97% to 98.5% by diagnosing and resolving high-priority production issues, significantly improving app stability and user experience.',
        'Engineered a proof of concept RAG pipeline to automatically capture and store bug fixes in a database, allowing LLM-driven retrieval during crashes for faster RCA and reduced resolution time.',
        'Refactored legacy handler-based asynchronous logic to Kotlin coroutines, reducing app crashes and improving responsiveness on android devices under high concurrency.',
      ],
    },
    {
      company: 'Refold AI',
      position: 'Software Development Engineer Intern',
      duration: 'July 2025 - August 2025',
      points: [
        'Led Ashby ATS integration, delivering 15+ RESTful API endpoints for candidate management, job postings.',
        'Migrated integration services from the v1 to v2 JSON schema (OpenAPI 3.0.3); enabling schema-driven UI/UX improvements and LLM-compatible metadata, replacing static actions with runtime-schema-based actions.',
        'Resolved high-priority sprint issues and improved system stability in production apps; integrated OAuth 2.0 / OIDC for existing services, enhancing security and reducing authentication-related support requests.',
      ],
    },
    {
      company: 'NeuraCamp',
      position: 'Founding Engineer',
      duration: 'May 2025 - Present',
      points: [
        'Spearheaded backend POC for a data science Ed-Tech platform, optimizing database schema design for execution tracking and modularity, achieving a 30% improvement in query performance and low-latency data.',
        'Architected a scalable Python-based code execution engine prototype using Judge0 CE and Docker, planned for ML/DL workloads and tested to handle 50,000+ concurrent sandboxed executions.',
        'Prepared a kubernetes deployment POC with autoscaling and job orchestration, enabling zero-downtime releases and supporting thousands of simultaneous executions with 40% faster job scheduling.',
      ],
    }
  ];
  
  


  export const ProjectData = [
    {
      id: 1,
      title: 'SmartReach',
      description: 'AI-powered CRM platform that streamlines business management and delivers actionable analytics for smarter decisions.',
      image: "./smartreach.png",
      projectLink: 'https://SmartReach.netlify.app/',
      codeLink: 'https://github.com/rvk7021/mini-crm-platform',
      tags: ['Web App', 'Full Stack'],
      techStack: ['React', 'Tailwind', 'Express', 'MongoDB', 'Gemini AI', 'Redis' ],
      date: '2025-05-06',
    },
    {
      id: 2,
      title: 'Codebit',
      description: 'All-in-one coding platform featuring a live compiler, problem tracking, and real-time contest updates.',
      image: "./codebit.png",
      projectLink: 'https://codebit-sr.netlify.app/',
      codeLink: 'https://github.com/rvk7021/Codebit',
      tags: ['Web App', 'Full Stack'],
      techStack: ['React', 'Tailwind', 'Express', 'MongoDB' ],
      date: '2025-01-01',
    },
    {
      id: 3,
      title: 'Portfolio Website',
      description: 'A dynamic and interactive personal website—yes, the one you’re exploring right now!',
      image: "./portfolio.png",
      projectLink: 'https://ranvijayk.netlify.app',
      codeLink: 'https://github.com/rvk7021/portfolio',
      tags: ['Web App', 'Personal'],
      techStack: ['React', 'CSS', 'JavaScript'],
      date: '2024-07-01',
    },
    {
      id: 4,
      title: 'CollegeCampus',
      description: 'Comprehensive college management app with seamless user experience, built on the MERN stack.',
      image: "./collegecampus.png",
      projectLink: 'https://github.com/rvk7021/CollegeCampus',
      codeLink: 'https://github.com/rvk7021/CollegeCampus',
      tags: ['Web App', 'Full Stack'],
      techStack: ['SQL', 'Express.js', 'React', 'Node.js', 'Tailwind CSS'],
      date: '2024-10-10',
    },
    {
      id: 5,
      title: 'Wanderlust',
      description: 'A vibrant tourism platform offering everything from bookings to travel inspiration, all in one place.',
      image: "./wanderlust.png",
      projectLink: 'https://github.com/rvk7021/Wanderlust',
      codeLink: 'https://github.com/rvk7021/Wanderlust',
      tags: ['Web App', 'E-Commerce'],
      techStack: ['HTML', 'CSS', 'PHP', 'SQL', 'JavaScript'],
      date: '2024-03-15',
    },
    {
      id: 6,
      title: "Surveillance and Drone Detection",
      description: "Cutting-edge AI system for real-time drone detection and intelligent surveillance.",
      image: "./surv.png",
      projectLink: "https://github.com/rvk7021/Military-surv",
      codeLink: "https://github.com/rvk7021/Military-surv",
      tags: ["ML"],
      techStack: ["Python", "TensorFlow", "OpenCV", "Pandas", "NumPy"],
      date: "2024-03-15"
    },
        {
      id:7 ,
      title: "GenAI assistant",
      description: "A versatile assistant that can summarize, translate, and answer questions using Gemini AI.",
      image: "./smart-assist.png",
      projectLink: "https://smart-assist.netlify.app/",
      codeLink: "https://github.com/rvk7021/GenAI-Research-Assistant",
      tags: ["mlweb"],
      techStack: ["Python", "FastAPI", "React", "Tailwind", "Gemini"],
      date: "2024-03-15"
    },
            {
      id:8,
      title: "Stock-Zenith",
      description: "An intelligent portfolio management tool offering real-time stock tracking, AI-powered insights, and an interactive chatbot for advanced investment analysis.",
      image: "./stock-zenith.png",
      projectLink: "https://stock-zenith.vercel.app/",
      codeLink: "https://github.com/rvk7021/StockZenith",
      tags: ["mlweb"],
      techStack: ["Gemini", "NextJs", "Typescript",  "MongoDB","Prisma"],
      date: "2024-03-15"
    }
  ];
  
  
  
  
  

  